export default __webpack_public_path__ + "static/media/Definix-guide2-06.ca40e468.png";